export default __webpack_public_path__ + "static/media/bg.071f2689.jpg";